export interface SellingCompanyWarehouse {
  id: string;
  sellingCompanyId: string;
  sellingCompanyKey: string;
  sellingCompanyName: string;
  warehouseId: string;
  warehouseKey: string;
  warehouseDescription: string;
  default: boolean;
  defaultYesNo: string;
}
